import React from "react";
import OrdersDashboard from "./OrdersDashboard";

function Ordering() {
  return <OrdersDashboard userRole="Admin" />;
}

export default Ordering;
